// assets/theme-analytics.js

// Event 13: Search Result Click
document.addEventListener('click', function(event) {
  if (!(event.target instanceof Element)) return;
  var resultItem = event.target.closest('.predictive-search__item, [data-search-result-item]');
  if (resultItem) {
    var searchInput = document.querySelector('input[type="search"]');
    var listContainer = resultItem.parentElement;
    if (!listContainer) return;
    
    // Safety check: Filter out non-product elements (like section headings) from the position calculation
    var validItems = Array.from(listContainer.children).filter(function(child) {
      return child.matches('.predictive-search__item, [data-search-result-item]');
    });
    var position = validItems.indexOf(resultItem) + 1;

    if (window.Shopify && window.Shopify.analytics) {
      window.Shopify.analytics.publish('theme:search_result:click', {
        search_query: searchInput instanceof HTMLInputElement ? searchInput.value : '',
        // Note: Ensure you add data-product-id="{{ product.id }}" to your search result HTML snippet
        product_id: resultItem.getAttribute('data-product-id') || resultItem.getAttribute('href'), 
        result_position: position
      });
    }
  }
});

// Event 8: Facet / Filter Apply
document.addEventListener('change', function(event) {
  if (!(event.target instanceof Element)) return;
  var facetInput = event.target.closest('.facets__input, input[name^="filter."], select[name^="filter."]');
  if (facetInput && (facetInput instanceof HTMLInputElement || facetInput instanceof HTMLSelectElement)) {
    // Condition allows select dropdowns to fire, but restricts checkboxes/radios to only fire when checked
    if ((facetInput.type !== 'checkbox' && facetInput.type !== 'radio') || ('checked' in facetInput && facetInput.checked)) {
      if (window.Shopify && window.Shopify.analytics) {
        window.Shopify.analytics.publish('theme:facet:apply', {
          filter_group: facetInput.name,
          filter_value: facetInput.value
        });
      }
    }
  }
});

// Event 9: Sort Order Change
document.addEventListener('change', function(event) {
  if (!(event.target instanceof Element)) return;
  var sortSelect = event.target.closest('#SortBy, [name="sort_by"]');
  if (sortSelect && (sortSelect instanceof HTMLSelectElement || sortSelect instanceof HTMLInputElement)) {
    if (window.Shopify && window.Shopify.analytics) {
      window.Shopify.analytics.publish('theme:sort:change', {
        sort_by: sortSelect.value
      });
    }
  }
});
